
import { submit as dynamicSearchSubmit } from "./dynamic-search.js"
import { lockout } from "./utilities.js";
import { positionPickerPanel, updateUrlSearchParams } from "./pickers-init.js"
import { getSearchBarOptions } from "./search-bar.js";
import Mustache from "./mustache.js"

let prevFocus;
let tmpFolks = '';
const activeClass = 'is-active';
const isBookingWidget = $('#form-property-bookingwidget');
const $pickerBlock = isBookingWidget.length ? isBookingWidget : $('#form-searchblock');
const $folksSelectorTrigger = $pickerBlock.find('.js-folks-selector-trigger');
const isSearchResultsPage = $pickerBlock.hasClass('js-dynamic-search');
const confirmChoice = $pickerBlock.find('.js-folks-selector-popup-submit');

const panelIsOpen = () => $pickerBlock.find('.js-folks-selector-popup').hasClass(activeClass)

const closeAllPanels = () => {
	$pickerBlock.find('.c-pickers-panel').removeClass(activeClass);
	$pickerBlock.find('.js-date-picker-wrapper, .js-folks-selector-trigger, .js-airport-picker-trigger, .js-destination-picker-trigger').removeClass(activeClass);
	lockout.off();
}

const saveFolksValuesToTmp = () => {
	const infantsCount = $pickerBlock.find('.js-infants').val() || '';
	const childrenCount = $pickerBlock.find('.js-children').val() || '';
	const adultsCount = $pickerBlock.find('.js-adults').val() || '';

	tmpFolks = `${infantsCount}|${childrenCount}|${adultsCount}`;
}

const haveSearchValuesChanged = () => {
	// Folks selector is different from others as it uses non-hidden inputs to show the values to the user and send the inputs in the querystring
	// So instead we read the values on panel open, store them and then do a comparison on close/apply
	const infantsCount = $pickerBlock.find('.js-infants').val() || '';
	const childrenCount = $pickerBlock.find('.js-children').val() || '';
	const adultsCount = $pickerBlock.find('.js-adults').val() || '';
	const compareStr = `${infantsCount}|${childrenCount}|${adultsCount}`;

	if (compareStr !== tmpFolks) {
		return true
	}

	return false;
}

const calculatePeople = function() {
	let adults = 0;
	let children = 0;
	let infants = 0;
	const inputsRow = $pickerBlock.find('.js-folks-selector-popup-row');

	inputsRow.each(function() {
		const inputs = $(this);
		adults += parseInt(inputs.find('.js-folks-selector-popup-row-adults').val());
		children += parseInt(inputs.find('.js-folks-selector-popup-row-children').val());
		infants += parseInt(inputs.find('.js-folks-selector-popup-row-infants').val());
	});

	return { adults, children, infants };
}

const calculatePeopleAndShowMessage = function() {
	const peopleCount = calculatePeople();
	$pickerBlock.find('.js-folks-selector-trigger-adults').text(peopleCount.adults);
	$pickerBlock.find('.js-folks-selector-trigger-children').text(peopleCount.children);
	$pickerBlock.find('.js-folks-selector-trigger-infants').text(peopleCount.infants);
}

const setOccupancyLimits = function(minOccupancy, maxOccupancy, absoluteMaxChildOccupancy) {
	$pickerBlock.find('.js-adults').not('.js-booking-widget-wrapper .js-adults').each(function() {
		const row = $(this);
		row.attr('min', minOccupancy);
		row.attr('max', maxOccupancy);
		row.attr('data-combined-max', maxOccupancy);
	});

	const maxChildOccupancy = maxOccupancy > absoluteMaxChildOccupancy ? absoluteMaxChildOccupancy : maxOccupancy;
	$pickerBlock.find('.js-children').not('.js-booking-widget-wrapper .js-children').each(function() {
		const row = $(this);
		row.attr('max', maxChildOccupancy);
		row.attr('data-combined-max', maxOccupancy);
	});
}

const init = function() {
	closeAllPanels()
	populatePanel()
	attachEvents();
	// Property page needs multiroomdisabledroomconfigs to change to roomconfigs
	if (!$('.m-folks-selector--in-search-block').length) {
		multiroomEnabledCheck();
	}
	else {
		multiroomEnabledCheck('MultiRoomUnavailable');
	}

	$pickerBlock.find('.m-search-block__form__row--people .m-search-block__form__row__label').on('click', function() {
		$folksSelectorTrigger.trigger('click')
	})
}

const populatePanel = () => {
	const templateEl = $('#folkSelectorTemplate');
	const templateHtml = templateEl.html();
	const singleroom = window.singleroom;
	const roomRendered = Mustache.render(templateHtml, singleroom);

	$pickerBlock.find('.js-search-block-wrapper-rooms').html(roomRendered);
}

const multiroomEnabledCheck = (multiroomAvailability) => {
	let configType;
	if (multiroomAvailability === 'MultiRoomUnavailable') {
		configType = 'multiroomdisabledroomconfigs'
	}
	else if (multiroomAvailability === 'MultiRoomAvailable') {
		configType = 'multiroomenabledroomconfigs'
	}
	else {
		configType = 'roomconfigs';
	}

	$pickerBlock.find('.js-folks-selector-popup-row-infants').attr('name', `${configType}[0].infants`)
	$pickerBlock.find('.js-folks-selector-popup-row-children').attr('name', `${configType}[0].children`)
	$pickerBlock.find('.js-folks-selector-popup-row-adults').attr('name', `${configType}[0].adults`)
}

const attachEvents = () => {
	$pickerBlock.find('.js-folks-selector-trigger').on('click keypress', function(e) {
		if (e.type === 'click' || (e.type === 'keypress' && e.which === 13)) {
			if (panelIsOpen()) {
				closeAllPanels()
				closeFolksSelectorPanel()
				window.site.body.off('click.folks', (e) => removeCloseListener(e))
			}
			else {
				closeAllPanels()
				openFolksSelectorPanel()
				window.requestAnimationFrame(() => {
					window.site.body.on('click.folks', (e) => removeCloseListener(e))
				})
			}
		}

		e.preventDefault();
	});

	$pickerBlock.on('click', '.js-folks-selector-popup-close, .js-folks-selector-popup-submit', function() {
		closeFolksSelectorPanel();
	});

	$pickerBlock.on('click', '.js-quantity-button', function(e) {
		if (e.type === 'click' || ((e.type === 'keypress') && e.which === 13)) {
			const button = $(this);
			const input = button.closest('.js-quantity-wrapper').find('input');
			const currentValue = parseInt(input.val());
			let newVal = '';

			if (button.attr('data-folks-selector-increase')) {
				newVal = currentValue + 1;
				const max = maxValue(input);

				if (newVal > max) {
					newVal = max;
				}
			}
			else {
				const smallestValue = parseInt(input.attr('min'));
				newVal = currentValue > smallestValue ? currentValue - 1 : smallestValue;

				updateDependentInput(input, newVal);
			}

			input.val(newVal);
			calculatePeopleAndShowMessage();
		}
	});

	// confirm choice
	confirmChoice.on('click', function() {
		calculatePeopleAndShowMessage();
		closeFolksSelectorPanel();
	});

	window.site.body.on('pickersTabChange', (e) => {
		const roomType = e.multiroomType;
		multiroomEnabledCheck(roomType)
	});
}

const removeEvents = () => {
	confirmChoice.off('click')
	$pickerBlock.off('click', '.js-quantity-button')
	$pickerBlock.off('click', '.js-folks-selector-popup-close, .js-folks-selector-popup-submit')
	$pickerBlock.find('.js-folks-selector-trigger').off('click keypress')
}

const removeCloseListener = (event) => {
	if (!event.target.closest('.js-folks-selector-trigger, .m-folks-selector__trigger, .js-folks-selector-popup')) {
		closeFolksSelectorPanel();
	}
}

const openFolksSelectorPanel = () => {
	prevFocus = document.activeElement;
	isBookingWidget ? lockout.on() : lockout.on('tablet');

	window.site.win.on('resize', () => {
		positionPickerPanel($pickerBlock, $folksSelectorTrigger)
	});
	positionPickerPanel($pickerBlock, $folksSelectorTrigger)
	saveFolksValuesToTmp()
	$pickerBlock.find('.js-folks-selector-trigger, .js-folks-selector-popup').addClass(activeClass);

	const $folksSelectorPicker = $pickerBlock.find('.js-folks-selector-ppopup');
	$folksSelectorPicker.find('select, button, [href], input, [tabindex]:not([tabindex="-1"])').first().focus();

	window.requestAnimationFrame(() => {
		window.site.body.on('click.folks', (e) => removeCloseListener(e))
	})
}

const closeFolksSelectorPanel = () => {
	if (haveSearchValuesChanged() && isSearchResultsPage) {
		getSearchBarOptions();
		updateUrlSearchParams()
		dynamicSearchSubmit(false);
	}

	$pickerBlock.find('.js-folks-selector-trigger, .js-folks-selector-popup').removeClass(activeClass);
	window.site.win.off('resize', () => {
		positionPickerPanel($pickerBlock, $folksSelectorTrigger)
	});

	window.site.body.off('click.folks')
	lockout.off();
	prevFocus?.focus();
}

const maxValue = (input) => {
	let max = parseInt(input.attr('max'));

	const combinedMax = combinedMaxValue(input);
	if (combinedMax === 0 || combinedMax > 0) {
		max = Math.min(max, combinedMax);
	}

	const dependentMax = dependentMaxValue(input);
	if (dependentMax === 0 || dependentMax > 0) {
		max = Math.min(max, dependentMax);
	}

	return max;
}

const combinedMaxValue = (input) => {
	const combinedMax = parseInt(input.attr('data-combined-max'));
	const combinedMaxInput = $('#' + input.attr('data-combined-max-with'));
	const otherInputvalue = parseInt(combinedMaxInput.val()) || 0;

	return combinedMax > 0 && (otherInputvalue === 0 || otherInputvalue > 0) ? combinedMax - otherInputvalue : null;
}

const dependentMaxValue = (input) => {

	const maxDependentOnInput = $(`#${input.attr('data-max-dependent-on')}`);
	const maxDependentValue = parseInt(maxDependentOnInput.val());

	return (maxDependentValue === 0 || maxDependentValue > 0) ? maxDependentValue : null;
}

const updateDependentInput = (input, newVal) => {
	const dependentMaxInput = $(`#${input.attr('data-governs-max-of')}`);
	const dependentMaxInputValue = parseInt(dependentMaxInput.val());

	if (dependentMaxInputValue && dependentMaxInputValue > newVal) {
		dependentMaxInput.val(newVal);
	}
}

export default init;

export { setOccupancyLimits, removeEvents, attachEvents };
